module.exports = __webpack_public_path__ + "static/media/recorte-3.7e09a4e7.png";